<template>
  <div class="test-page">
    <div class="container">
      <div class="comp-container">
        <jt-form
          class="form-comp"
          :items="items"
          :cols="3"
          @datas="handleFormDatas"
          @image-upload-success="handleImageUploadSuccess"
          @image-delete="handleImageDelete"
          @music-upload-success="handleMusicUploadSuccess"
          @music-delete="handleMusicDelete"
        />
      </div>
      <div class="comp-container">
        <jt-table
          class="table-comp"
          :columns="tableColumns"
          :rows="tableRows"
          createButton
          copyButton
          deleteButton
          @datas="handleTableDatas"
          @image-upload-success="handleTableImageUploadSuccess"
          @image-delete="handleTableImageDelete"
          @music-upload-success="handleTableMusicUploadSuccess"
          @music-delete="handleTableMusicDelete"
          @create-a-line="handleCreateALine"
          @copy-a-line="handleCopyALine"
          @delete-lines="handleDeleteLines"
        />
      </div>
      <div class="comp-container">
        <el-select v-model="val" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import suggestions from '../../mock/tips.json'
import testImage from '../../mock/test_image.jpeg'
import testMusic from '../../mock/test_music.mp3'
import items from '../../mock/items.json'
import tableColumns from '../../mock/tableColumns.json'
import tableRows from '../../mock/tableRows.json'

import Formatter from '../../utils/formatter'

import jtForm from '../../components/form'
import jtTable from '../../components/table'

export default {
  name: 'Test',
  components: {
    jtForm,
    jtTable
  },
  data() {
    return {
      suggestions,
      testImage,
      testMusic,
      items: [],
      tableColumns: [],
      tableRows: [],
      options: [
        {
          value: '选项1',
          label: '黄金糕'
        },
        {
          value: '选项2',
          label: '双皮奶'
        },
        {
          value: '选项3',
          label: '蚵仔煎'
        },
        {
          value: '选项4',
          label: '龙须面'
        },
        {
          value: '选项5',
          label: '北京烤鸭'
        }
      ],
      val: '北京烤鸭'
    }
  },
  methods: {
    async handleFormDatas(err, index, data, cb) {
      let res = true
      if (err) {
        res = false
        const title = this.$t('global.ERROR')

        await this.$alert(err.message, title, {
          type: 'error',
          showClose: false
        })

        cb(res)
        return
      }
      cb(res)
    },
    async handleTableDatas(err, row, column, data, cb) {
      let res = true
      if (err) {
        res = false
        const title = this.$t('global.ERROR')

        await this.$alert(err.message, title, {
          type: 'error',
          showClose: false
        })

        cb(res)
        return
      }
      cb(res)
    },
    handleImageUploadSuccess(index) {
      console.log('image upload success: ', this.items[index])
    },
    handleImageDelete(index) {
      console.log('delete image: ', this.items[index])
    },
    handleMusicUploadSuccess(index) {
      console.log('music upload success: ', this.items[index])
    },
    handleMusicDelete(index) {
      console.log('delete music: ', this.items[index])
    },
    handleTableImageUploadSuccess(row, col) {
      console.log('image upload success: ', row, col)
    },
    handleTableImageDelete(row, col) {
      console.log('delete image: ', row, col)
    },
    handleTableMusicUploadSuccess(row, col) {
      console.log('music upload success: ', row, col)
    },
    handleTableMusicDelete(row, col) {
      console.log('delete music: ', row, col)
    },
    handleCreateALine() {
      console.log('create a line')
    },
    handleCopyALine(line) {
      console.log('copy a line: ', line)
    },
    handleDeleteLines(lines) {
      console.log('delete lines: ', lines)
    }
  },
  created() {
    this.items = _.map(items, item => {
      if (item.type === 'jtSingleProject' || item.type === 'jtGroupProject') {
        item.suggestions = suggestions
      }

      if (item.type === 'jtImage') {
        item.src = testImage
      }

      if (item.type === 'jtMusic') {
        item.src = testMusic
        item.musicName = '好听的歌'
      }
      return item
    })

    this.tableColumns = Formatter.formatTableColumns(tableColumns)
    this.tableRows = Formatter.formatTableRows(
      tableRows,
      _.map(tableColumns, tableColumn => {
        return tableColumn.colId
      })
    )

    this.tableColumns = _.map(this.tableColumns, item => {
      if (
        item.component.type === 'jtSingleProject' ||
        item.component.type === 'jtGroupProject'
      ) {
        item.component.property.suggestions = suggestions
      }

      return item
    })

    this.tableRows = _.map(this.tableRows, item => {
      if (item.image.value === 'test') {
        item.image.value = testImage
      }

      if (item.music.value === 'test') {
        item.music.value = testMusic
        item.music.musicName = '好听的歌'
      }

      return item
    })
  }
}
</script>

<style lang="stylus" scoped>
.comp
  width 300px
  margin-right 30px
.comp-container
  width: 100%
  overflow auto
  display flex
  flex-direction row
  align-items baseline
  margin-bottom 10px
.form-comp
  width 100%
</style>
